// extracted by mini-css-extract-plugin
export default {"zoomControls":"T--z","zoomControlButton":"U--z","zoomBanner":"V--z","bannerButton":"W--z","imageButton":"X--z","zoom":"Y--z","zoomContent":"Z--z"};